import dayjs from 'dayjs';

export type PresetKey =
  | 'last24h'
  | 'last7d'
  | 'last30d'
  | 'last90d'
  | 'last12m';

export const EXPORT_LOG_PRESETS: { value: PresetKey; label: string }[] = [
  { value: 'last24h', label: 'Last 24 hours' },
  { value: 'last7d', label: 'Last 7 days' },
  { value: 'last30d', label: 'Last 30 days' },
  { value: 'last90d', label: 'Last 90 days' },
  { value: 'last12m', label: 'Last 12 months' },
];

export const getStartDateForPreset = (key: PresetKey): string => {
  switch (key) {
    case 'last24h':
      return dayjs().subtract(24, 'hour').toISOString();
    case 'last7d':
      return dayjs().subtract(7, 'day').startOf('day').toISOString();
    case 'last30d':
      return dayjs().subtract(30, 'day').startOf('day').toISOString();
    case 'last90d':
      return dayjs().subtract(90, 'day').startOf('day').toISOString();
    case 'last12m':
      return dayjs().subtract(12, 'month').startOf('day').toISOString();
    default:
      throw new Error(`No start date defined for preset key: ${key}`);
  }
};
